interface TimelineConnectorLineProps {
  className?: string;
  variant?: 'line' | 'terminal';
}

export function TimelineConnectorLine({
  className,
  variant = 'line',
}: TimelineConnectorLineProps) {
  if (variant === 'terminal') {
    return (
      <div
        data-testid='timeline-terminal-marker'
        className={`absolute w-px bg-border-secondary ${className ?? ''}`}
      >
        <div className='absolute left-1/2 -translate-x-1/2 bottom-0 w-1.5 h-1.5 rounded-full bg-border-secondary' />
      </div>
    );
  }
  return (
    <div className={`absolute w-px bg-border-secondary ${className ?? ''}`} />
  );
}
